import {ApiService} from "./Http";
import {MithraLoginResponse} from "./ApiTypes";
import axios from "axios";
import {environment} from "../env";

export default class AuthApi extends ApiService {
}
